module.exports = __webpack_public_path__ + "img/big.855d37a3.png";